import React, { ReactElement } from 'react';
import { TerminDetail } from 'tezaury-frontend-ts-axios';
import { Col, Row } from 'idsk-react-components';
import { useNavigate } from 'react-router';
import DetailTerminuSectionHeading
  from '../DetailTerminuSectionHeading/DetailTerminuSectionHeading';
import TerminDetailEmptyDataMessage
  from '../TerminDetailEmptyDataMessage/TerminDetailEmptyDataMessage';
import routes from '../../../routing/routes';
import './detailTerminuPoznamka.scss';

interface Props {
  termin: TerminDetail;
  admin?: boolean;
}

const DetailTerminuPoznamka = ({ termin, admin = false } : Props): ReactElement => {
  const navigate = useNavigate();
  return (
    <>
      {(admin || termin.poznamka) && (
        <div className="detail-terminu-poznamka">
          <DetailTerminuSectionHeading
            heading="Poznámky"
            admin={admin}
            onClick={() => navigate(routes.tezaurus.admin.termin.edit.poznamka
              .withParams(termin.tezaurus.uuid, termin.uuid))}
            terminListNotEmpty={termin.poznamka && termin.poznamka.length > 0}
          />

          {admin && !termin.poznamka && (
            <TerminDetailEmptyDataMessage text="Termín nemá žiadne poznámky." />
          )}

          <Row>
            <Col width="two-thirds" className="detail-terminu-poznamka-text">
              {termin.poznamka}
            </Col>
          </Row>
        </div>
      )}
    </>
  );
};

export default DetailTerminuPoznamka;
